import React from 'react';

import Zoom from 'assets/images/icon/Zoom';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { textTransform } from 'util/textTransform';
import DeleteIcon from "../../../../assets/images/icon/DeleteIcon";
import ClockIcon from "../../../../assets/images/icon/ClockIcon";
import TrashCanDark from "../../../../assets/images/icon/TrashCanDark";
import {dateUtil, isEmpty} from "../../../../util";
import CloseCircle from "../../../../assets/images/icon/CloseCircle";
import {coachingAPI} from "../../../../api/coachingAPI";
import {fadeIn} from "../../../../styled/StyledComponent";

const returnColor = (text) => {
    switch (text) {
        case "New": {
            return "#FFC8DD";
        }
        case "RECEIVED": {
            return "#B0CBFF";
        }
        case "DRAFT": {
                return "#F0A8A8";
        }
        case "IN_PROGRESS": {
            return "#FFFAA0";
        }
        case "PUBLISHED": {
            return "#A2BFFE";
        }
            // #A2BFFE
        default:
            break;
    }
};
const InProgressList = (props) => {
    const navigate = useNavigate();

    const onClickEdit = (progress) => {
        switch (progress){
            case "DRAFT" : {
                return {
                    icon:<TrashCanDark/>,
                    event:() => {props?.onClickIcon(props?.data?.id)}
                }
            }
            case "IN_PROGRESS"  : {
                return {
                    icon:<ClockIcon/>,
                    event:() => {
                        props?.onClickSelect(props?.data)
                        props?.onClickTimePopup();
                    }
                }
            }
            case "PUBLISHED" : {
                return {
                    icon:<ClockIcon/>,
                    event:() => {
                        props?.onClickSelect(props?.data)
                        props?.onClickTimePopup();
                    }
                }
            }
            default : {
                return {
                    icon:<></>,
                    event:() => {}
                }
            }
        }
    }
    const returnData = (date) => {
        // const c = cloneDeep(date)?.map((item, index) => {
        //     if (index === 1) {
        //         item = item - 1;
        //     }
        //     return item;
        // });
        // let ms = dayjs(Date.UTC.apply(null, c?.slice(0, 6)))
        //     .utc()
        //     .locale("en")
        //     .format("MMM DD, YYYY");
        return date;
    };

    const putAdminProgress = async () => {
        if(props?.data?.progress === "IN_PROGRESS"){
            await coachingAPI.putAdminSubmitCoaching(props?.data?.id,{
                params:{
                    progress:"DRAFT"
                }
            })
                .then(res => {
                    props.onClickGetList()
            })
        }else{
            await coachingAPI.putCoachingPauseStåte(props?.data?.id,{
                params:{
                    pause:!props?.data?.pause
                }
            })
                .then(res => {
                    props.onClickGetList()
                })
        }
    }
    const checkTimeAway = () => {
        if(isEmpty(props?.data?.coachingTypes)) return false
        const c = cloneDeep(props?.data);
        const check = c?.coachingTypes?.findIndex(item => {
            return item?.timeAway === true
        })

        if(check !== -1){
            return true
        }else{
            return false
        }
    }
    console.log('listData', props?.data)
    // @ts-ignore
    return (
        <Container>       
            <Thumb>
                <img src={props?.data?.thumbnail?.url ?? "/images/homeworkImg.png"} alt="" />
                <EditIcon className={"edit"}
                    onClick={()=>{
                        onClickEdit(String(props?.data?.progress))?.event()
                    }}
                >
                    {onClickEdit(String(props?.data?.progress))?.icon}
                </EditIcon>
                <ClassInfo>
                    <span>
                   {props?.classTitle}
                    </span>
                </ClassInfo>
            </Thumb>
            <ListMain>
                <CategoryList>
                    <Category
                        style={{
                            background:props?.data?.inProgress !== null ? "#A2BFFE" : returnColor(String(props?.data?.progress)),
                        }}
                    >
                        <span>{textTransform().capitalizeFirstLetter(String(props?.data?.progress)?.toLocaleLowerCase()) === "In_progress" ? (props?.data?.inProgress === null ? "in progress" : "scheduled") :
                        textTransform().capitalizeFirstLetter(String(props?.data?.progress)?.toLocaleLowerCase())}</span>
                    </Category>
                    {
                        checkTimeAway() === true &&
                        <Category
                            onClick={()=>{
                                props?.onClickSelect(props?.data)
                                props?.onClickTimePopup(props?.data);
                            }}
                            style={{
                                background: "#CDB4DB",
                                cursor:"pointer"
                            }}
                        >
                            <span>Time Away</span>
                        </Category>
                    }

                    {
                        props?.data["24hr"] === true &&
                        <Category
                            style={{
                                background: "#BDE0FE",
                                cursor:"pointer"
                            }}
                        >
                            <span>24 hours</span>
                        </Category>
                    }
                    <Category
                        style={{
                            background: "#fff",
                            border:"solid 1px #333",
                            opacity:props?.data?.pause ? 1 : 0,

                        }}
                    >
                        <span>Pause</span>
                    </Category>
                </CategoryList>
                    <h3>
                    {props?.data?.title}
                    </h3>
                <DateItem
                    className={"date"}
                    style={{marginBottom: 0}}>
                    <p>
                        {/*{dateUtil.mainCardDateFormat(props?.data?.updatedDatetime)}  */}
                        Received Date: <b>{returnData(props?.data?.updatedDatetime)}</b>
                    </p>

                </DateItem>

            </ListMain>
            <ListButton
                style={{cursor: "pointer"}}
                className={"adminOption pauseBtn"}
                onClick={() => {
                    putAdminProgress()
                }}>
                {
                    props?.data?.progress === "IN_PROGRESS" ?
                        <span>Return</span> :
                        <span>{props?.data?.pause ? "Open" : "Pause"}</span>
                }
                {props?.data?.progress === "IN_PROGRESS" ? (
                    // <CloseCircle/>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" fill="#333333" fill-opacity="0.1"/>
                        <path d="M12.6897 7.7233H3.97629L7.13216 4.56744C7.23974 4.45985 7.23974 4.28496 7.13216 4.17737C7.02457 4.06978 6.84967 4.06978 6.74209 4.17737L3.11505 7.8044C3.00747 7.91199 3.00747 8.08689 3.11505 8.19447L6.74209 11.8215C6.79616 11.8756 6.86678 11.9021 6.9374 11.9021C7.00802 11.9021 7.07864 11.875 7.13271 11.8215C7.24029 11.7139 7.24029 11.539 7.13271 11.4314L3.97685 8.27558H12.6897C12.8419 8.27558 12.9655 8.15199 12.9655 7.99971C12.9655 7.84744 12.8419 7.7233 12.6897 7.7233Z" fill="#333333"/>
                    </svg>
                ) : (
                    <>
                        {
                            props?.data?.pause
                                ?
                                <svg width="9" height="11" viewBox="0 0 9 11" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g id="Group 1000004869">
                                        <path id="Vector"
                                              d="M6.24939 3.55701H2.08313V3.1371C2.083 2.6716 2.23638 2.21925 2.51914 1.85117C2.8019 1.4831 3.19801 1.22017 3.6452 1.10373C4.09239 0.987292 4.56529 1.02394 4.98956 1.20792C5.41383 1.3919 5.7654 1.71277 5.989 2.12009C6.01556 2.16831 6.05129 2.21079 6.09414 2.2451C6.13699 2.2794 6.18613 2.30487 6.23874 2.32004C6.29136 2.3352 6.34642 2.33978 6.40079 2.3335C6.45516 2.32722 6.50777 2.31021 6.55561 2.28343C6.60346 2.25666 6.6456 2.22065 6.67964 2.17747C6.71368 2.13428 6.73895 2.08476 6.75399 2.03173C6.76904 1.9787 6.77358 1.9232 6.76735 1.8684C6.76112 1.81361 6.74424 1.76058 6.71768 1.71236C6.4045 1.14226 5.91223 0.693215 5.31825 0.435809C4.72427 0.178404 4.06226 0.127235 3.43628 0.290346C2.8103 0.453457 2.25585 0.821599 1.86008 1.3369C1.46431 1.85221 1.24966 2.48545 1.24988 3.1371V3.73505C0.878815 3.89827 0.562984 4.16694 0.341008 4.50819C0.119032 4.84944 0.000532605 5.24849 0 5.65654V8.17598C0.000661543 8.73261 0.220346 9.26625 0.610866 9.65984C1.00138 10.0534 1.53085 10.2749 2.08313 10.2755H6.24939C6.80167 10.2749 7.33114 10.0534 7.72166 9.65984C8.11218 9.26625 8.33186 8.73261 8.33252 8.17598V5.65654C8.33186 5.09992 8.11218 4.56628 7.72166 4.17269C7.33114 3.77909 6.80167 3.55768 6.24939 3.55701ZM7.49927 8.17598C7.49927 8.51008 7.36759 8.8305 7.13319 9.06674C6.89879 9.30298 6.58088 9.4357 6.24939 9.4357H2.08313C1.75164 9.4357 1.43373 9.30298 1.19933 9.06674C0.964936 8.8305 0.833252 8.51008 0.833252 8.17598V5.65654C0.833252 5.32245 0.964936 5.00203 1.19933 4.76579C1.43373 4.52954 1.75164 4.39682 2.08313 4.39682H6.24939C6.58088 4.39682 6.89879 4.52954 7.13319 4.76579C7.36759 5.00203 7.49927 5.32245 7.49927 5.65654V8.17598Z"
                                              fill="#333333"/>
                                        <path id="Vector_2"
                                              d="M4.16663 6.07471C4.05613 6.07471 3.95016 6.11895 3.87203 6.19769C3.79389 6.27644 3.75 6.38325 3.75 6.49461V7.33443C3.75 7.44579 3.79389 7.5526 3.87203 7.63135C3.95016 7.71009 4.05613 7.75433 4.16663 7.75433C4.27712 7.75433 4.38309 7.71009 4.46123 7.63135C4.53936 7.5526 4.58325 7.44579 4.58325 7.33443V6.49461C4.58325 6.38325 4.53936 6.27644 4.46123 6.19769C4.38309 6.11895 4.27712 6.07471 4.16663 6.07471Z"
                                              fill="#333333"/>
                                    </g>
                                </svg>
                                :
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g id="Group 1000004578">
                                        <path id="Vector"
                                              d="M1.94445 0C1.42875 0 0.93417 0.153645 0.569516 0.427136C0.204861 0.700626 0 1.07156 0 1.45833V8.54167C1.08676e-08 8.92844 0.204861 9.29937 0.569516 9.57286C0.93417 9.84635 1.42875 10 1.94445 10C2.46015 10 2.95473 9.84635 3.31938 9.57286C3.68403 9.29937 3.8889 8.92844 3.8889 8.54167V1.45833C3.8889 1.07156 3.68403 0.700626 3.31938 0.427136C2.95473 0.153645 2.46015 0 1.94445 0ZM2.77778 8.54167C2.77778 8.70743 2.68999 8.8664 2.5337 8.98361C2.37742 9.10082 2.16546 9.16667 1.94445 9.16667C1.72343 9.16667 1.51147 9.10082 1.35519 8.98361C1.19891 8.8664 1.11111 8.70743 1.11111 8.54167V1.45833C1.11111 1.29257 1.19891 1.1336 1.35519 1.01639C1.51147 0.899181 1.72343 0.833333 1.94445 0.833333C2.16546 0.833333 2.37742 0.899181 2.5337 1.01639C2.68999 1.1336 2.77778 1.29257 2.77778 1.45833V8.54167Z"
                                              fill="#333333"/>
                                        <path id="Vector_2"
                                              d="M8.05773 0C7.54203 0 7.04745 0.153645 6.6828 0.427136C6.31814 0.700626 6.11328 1.07156 6.11328 1.45833V8.54167C6.11328 8.92844 6.31814 9.29937 6.6828 9.57286C7.04745 9.84635 7.54203 10 8.05773 10C8.57343 10 9.06801 9.84635 9.43266 9.57286C9.79732 9.29937 10.0022 8.92844 10.0022 8.54167V1.45833C10.0022 1.07156 9.79732 0.700626 9.43266 0.427136C9.06801 0.153645 8.57343 0 8.05773 0ZM8.89106 8.54167C8.89106 8.70743 8.80327 8.8664 8.64699 8.98361C8.4907 9.10082 8.27874 9.16667 8.05773 9.16667C7.83671 9.16667 7.62475 9.10082 7.46847 8.98361C7.31219 8.8664 7.22439 8.70743 7.22439 8.54167V1.45833C7.22439 1.29257 7.31219 1.1336 7.46847 1.01639C7.62475 0.899181 7.83671 0.833333 8.05773 0.833333C8.27874 0.833333 8.4907 0.899181 8.64699 1.01639C8.80327 1.1336 8.89106 1.29257 8.89106 1.45833V8.54167Z"
                                              fill="#333333"/>
                                    </g>
                                </svg>
                        }
                    </>
                )}
            </ListButton>
            <ListButton
                className={"black"}
                onClick={() => {
                // props.onClickPopup(props?.data)
                navigate("/create_coaching/details", {
                    state: {
                        createId: props?.data?.id
                    }
                })
            }}>
                <span>{props?.data?.progress === "PUBLISHED" ? "View" : "Edit"}</span>
                {props?.data?.progress !== "DRAFT" ? (
                    <Zoom/>
                ) : (
                    <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M13.6648 0.164752C13.8844 -0.0549174 14.2406 -0.0549174 14.4602 0.164752L17.8352 3.53975C18.0549 3.75942 18.0549 4.11557 17.8352 4.33524L6.58526 15.5852C6.53139 15.6391 6.46715 15.6815 6.39642 15.7098L0.771423 17.9598C0.562501 18.0433 0.323879 17.9943 0.164769 17.8352C0.00565862 17.6761 -0.0433205 17.4375 0.0402482 17.2286L2.29025 11.6036C2.31854 11.5329 2.3609 11.4686 2.41477 11.4147L13.6648 0.164752ZM12.608 2.8125L15.1875 5.392L16.642 3.9375L14.0625 1.35799L12.608 2.8125ZM14.392 6.18749L11.8125 3.60799L4.50001 10.9205V11.25H5.06251C5.37317 11.25 5.62501 11.5018 5.62501 11.8125V12.375H6.18751C6.49817 12.375 6.75001 12.6268 6.75001 12.9375V13.5H7.07951L14.392 6.18749ZM3.41062 12.0099L3.2919 12.1286L1.57223 16.4278L5.8714 14.7081L5.99012 14.5894C5.77683 14.5094 5.62501 14.3037 5.62501 14.0625V13.5H5.06251C4.75185 13.5 4.50001 13.2481 4.50001 12.9375V12.375H3.93751C3.69631 12.375 3.49056 12.2232 3.41062 12.0099Z"
                            fill="#333333"
                        />
                    </svg>
                )}
            </ListButton>
        </Container>
    );
};
export default InProgressList;

const ContentsInner = styled.div`
    padding: 20px;
    overflow: hidden;
`;

const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const Container = styled.div`
    display: flex;
    position: relative;
    padding: 20px 0;
    border-top: 1px solid rgba(51, 51, 51, 0.3);
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */

    .edit {
        transition: all 0.2s;
        opacity: 0;
        pointer-events: none;
    }

    &:hover {
        .edit {
            opacity: 1;
            pointer-events: all;
        }
    }
`;
const Thumb = styled.div`
    transition: all 0.2s;
    background: #ddd;
    width: 113px;
    height: 113px;
    border-radius: 5px;
    position: relative;

    img {
        display: block;
        border-radius: 5px;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

`;
const EditIcon = styled.div`
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        pointer-events: none;
    }

    cursor: pointer;
    width: 30px;
    height: 30px;
    transform: translate(-25%, -25%);
    border-radius: 50%;
    background: #fff;
    position: absolute;
    box-shadow: -1px 1px 4px 0px #3333331F;
`
const ClassInfo = styled.div`
    position: absolute;
    border-radius: 0 0 5px 5px;
    z-index: 9;
    width: 100%;
    padding-top: 7px;
    padding-bottom: 6px;
    display: flex;
    justify-content: center;
    background: #333;
    left: 0;
    bottom: 0;

    span {
        font-family: Europa-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
        letter-spacing: 0em;
        text-align: left;
        color: #fff;
    }
`
const ListMain = styled.div`
    padding: 0 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h3 {
        font-size: 26px;
        margin: -10px 0 9.6px 0;
    }
`;
const CategoryList = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;
const Category = styled.div`
    padding: 7px 12px;
    margin-right: 15px;
    height: 28px;
    background: #f0a8a8;
    transition: all 0.2s;
    cursor: default;
    min-width: 86px;
    font-size: 12px;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-bottom: 4px;
    font-weight: 700;
    span {
        text-transform: capitalize;
    }
`;
const DateItem = styled.div`
    display: flex;
    p {
        color: #33333385;
    }
    span {
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333ac;
    }
    &.date{
        p {
            font-family: "Source Serif 4", sans-serif;
            color: #333333;
            font-size: 14px;
            font-weight: 600;
            line-height: 14px;
            letter-spacing: 0em;
            text-align: left;
            opacity: 0.5;
        }
        span {
            font-size: 14px;
            font-weight: 600;
            line-height: 14px;
            letter-spacing: 0em;
            text-align: left;
            color: #333333ac;
        }
    }
`;

const Progress = styled.div`
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    color: rgba(51, 51, 51, 0.6);
    text-align: end;
    margin-bottom: 0.25rem;
    max-width: 500px;
    b {
        color: #333;
    }
`;
const ProgressBar = styled.div``;
const ListButton = styled.div`
    &.pauseBtn{
        border: solid 1px #333;
        &:hover{
            background: #333;
            span{
                color: #fff;
            }
            svg{
                display: block;
                path{
                    fill: #fff;
                }
            }
        }
        svg{
            display: block;
            path{
                fill: #333;
            }
        }
    }
    &.black{
        border: solid 1px #333;
        &:hover{
            background: #fff;
            span{
                color: #333;
            }
            svg{
                display: block;
                path{
                    fill: #333;
                }
            }
        }
        svg{
            display: block;
            path{
                fill: #fff;
            }
        }
    }
    
    transition: all 0.2s;
    background: #333;
    width: 87px;
    height: 30px;
    border-radius: 5px;
    overflow: hidden;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &.adminOption{
        margin-right: 5px;
        border: solid 1px #333;
        background: #fff;
        svg{
            transform: scale(1.2);
        }
        span{
            color: #333;    
        }
    }
    span {
        padding-top: 2px;
        margin-right: 10px;
        display: flex;
        height: 100%;
        align-items: center;
        color: #fff;
        box-shadow: none;
        border-radius: 5px;
        font-family: var(--fontFamilyRegular);
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
    }
`;

const Instructor = styled.div`
    margin-left: 20px;
`;
const User = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #333333d2;
`;
